import * as React from 'react';

const SvgHowToBook = (props) => (
  <svg
    id='HowToBook_svg__Layer_2'
    data-name='Layer 2'
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox='0 0 128 128'
    {...props}
  >
    <defs>
      <style>{'.HowToBook_svg__cls-1{fill:#fff}'}</style>
    </defs>
    <g id='HowToBook_svg__Layer_1-2' data-name='Layer 1'>
      <rect
        width={128}
        height={128}
        rx={32.53}
        ry={32.53}
        style={{
          fill: '#2673b0',
        }}
      />
      <g id='HowToBook_svg__d'>
        <path
          className='HowToBook_svg__cls-1'
          d='M65 24.2c-22.37 0-40.54 18.17-40.54 40.54S42.63 105.28 65 105.28s40.54-18.17 40.54-40.54S87.37 24.2 65 24.2Zm0 74.85c-18.92 0-34.31-15.39-34.31-34.31S46.08 30.43 65 30.43s34.31 15.39 34.31 34.31S83.92 99.05 65 99.05Z'
        />
        <path
          className='HowToBook_svg__cls-1'
          d='M65 40.83c-6.32 0-11.44 5.11-11.44 11.44 0 1.7 1.41 3.12 3.12 3.12s3.12-1.41 3.12-3.12c0-2.87 2.33-5.2 5.2-5.2s5.2 2.33 5.2 5.2c0 1.66-.79 3.2-2.12 4.2-3.95 2.87-6.2 7.03-6.2 11.35v1.08c0 1.7 1.41 3.12 3.12 3.12s3.12-1.41 3.12-3.12v-1.08c0-3.16 2.29-5.32 3.66-6.32 2.91-2.16 4.66-5.61 4.66-9.23 0-6.32-5.11-11.44-11.44-11.44ZM65 78.26c-1.7 0-3.12 1.41-3.12 3.12v3.49c0 1.7 1.41 3.12 3.12 3.12s3.12-1.41 3.12-3.12v-3.49c0-1.7-1.41-3.12-3.12-3.12Z'
        />
      </g>
    </g>
  </svg>
);
export default SvgHowToBook;
